import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _mergeProps({ ref: "wheelWrapper" }, _ctx.$attrs, {
        class: _ctx.getClasses.wrap,
        onClick: _cache[0] || (_cache[0] =
            //@ts-ignore
            (...args) => (_ctx.listener && _ctx.listener(...args)))
    }), [
        (_ctx.options.length)
            ? (_openBlock(), _createElementBlock("ul", {
                key: 0,
                class: _normalizeClass(_ctx.getClasses.scroll)
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSerializeOptions, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        class: _normalizeClass(_ctx.rangerItemClass(index))
                    }, [
                        (item.value)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(_ctx.getClasses.itemTitle)
                            }, _toDisplayString(item.value), 3))
                            : _createCommentVNode("", true)
                    ], 2));
                }), 128))
            ], 2))
            : _createCommentVNode("", true),
        _createElementVNode("i", {
            class: _normalizeClass(_ctx.getClasses.maskTop)
        }, null, 2),
        _createElementVNode("i", {
            class: _normalizeClass(_ctx.getClasses.maskBottom)
        }, null, 2)
    ], 16));
}
